import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
import { SITE_ASSETS } from "../mock";

export default function Footer() {
  const { settings } = useSettings();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#1F1B17] text-[#E8DCC4] relative">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-20 pb-10 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-14 h-14 rounded-full bg-white/95 flex items-center justify-center overflow-hidden">
              <img src={SITE_ASSETS.logo} alt="Tamra" className="w-12 h-12 object-contain" />
            </div>
            <div>
              <div className="font-display text-[24px] tracking-[0.28em] text-[#F5EFE6]">{settings.brandName}</div>
              <div className="text-[10px] tracking-[0.42em] text-[#B8893C] mt-1">{settings.brandSubtitle}</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-[#C9BFA9] max-w-md">
            {settings.tagline}. Tamra is a developer of considered, contemporary residences — where craft, restraint and warmth shape every detail.
          </p>
          <div className="flex items-center gap-4 mt-8">
            <a href={settings.social.instagram} className="w-10 h-10 rounded-full border border-[#B8893C]/40 flex items-center justify-center hover:bg-[#B8893C] hover:border-[#B8893C] transition"><Instagram size={16} /></a>
            <a href={settings.social.facebook}  className="w-10 h-10 rounded-full border border-[#B8893C]/40 flex items-center justify-center hover:bg-[#B8893C] hover:border-[#B8893C] transition"><Facebook size={16} /></a>
            <a href={settings.social.youtube}   className="w-10 h-10 rounded-full border border-[#B8893C]/40 flex items-center justify-center hover:bg-[#B8893C] hover:border-[#B8893C] transition"><Youtube size={16} /></a>
            <a href={settings.social.linkedin}  className="w-10 h-10 rounded-full border border-[#B8893C]/40 flex items-center justify-center hover:bg-[#B8893C] hover:border-[#B8893C] transition"><Linkedin size={16} /></a>
          </div>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.42em] text-[#B8893C] mb-5">EXPLORE</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-[#B8893C] transition">Home</Link></li>
            <li><Link to="/about" className="hover:text-[#B8893C] transition">About</Link></li>
            <li><Link to="/projects" className="hover:text-[#B8893C] transition">Projects</Link></li>
            <li><Link to="/services" className="hover:text-[#B8893C] transition">Services</Link></li>
            <li><Link to="/contact" className="hover:text-[#B8893C] transition">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.42em] text-[#B8893C] mb-5">REACH US</div>
          <ul className="space-y-4 text-sm text-[#C9BFA9]">
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-[#B8893C]" /> {settings.contact.address}</li>
            <li className="flex items-start gap-3"><Phone size={16} className="mt-0.5 text-[#B8893C]" /> {settings.contact.phone}</li>
            <li className="flex items-start gap-3"><Mail size={16} className="mt-0.5 text-[#B8893C]" /> {settings.contact.email}</li>
            <li className="text-xs text-[#9C937E] pt-1">{settings.contact.hours}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#3A2F26]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-[#9C937E]">
          <div>© {year} Tamra Developers. All rights reserved.</div>
          <div className="tracking-[0.3em] uppercase">Crafted with restraint · Built to last</div>
        </div>
      </div>
    </footer>
  );
}
